<template>
    <div :class="{'en': lang === 'en'}">
        <div class="card-title">
            修改派息安排
        </div>
        <div class="input-group">
            <label for="">{{$t('message.clientCode')}}：</label>
            <vs-input v-model="dividend.clientCode" readonly style="width: 100%"></vs-input>
        </div>
        <div class="input-group">
            <label for="">{{$t('message.clientName')}}：</label>
            <vs-input v-model="dividend.clientName" readonly style="width: 100%"></vs-input>
        </div>
        <div class="input-group">
            <label for="">{{$t('message.planName')}}：</label>
            <vs-input v-model="dividend.plan" readonly style="width: 100%"></vs-input>
        </div>
        <div class="input-group">
            <label for="">{{$t('message.dividendDate')}}：</label>
            <datepicker class="fixedPicker" v-model="dividend.datePayable" :format="format"
                        :highlighted="highlight" style="width: 100%"></datepicker>
        </div>
        <div class="input-group">
            <label for="">{{$t('message.interest1')}}：</label>
            <vs-input v-model="dividend.interest" type="number" style="width: 100%"></vs-input>
        </div>
        <div class="input-group" v-if="dividend.managementFee || dividend.managementFee === 0 || dividend.managementFee === ''">
            <label for="">{{$t('message.manageFee1')}}：</label>
            <vs-input v-model="dividend.managementFee" type="number" style="width: 100%"></vs-input>
        </div>
        <div class="input-group" v-if="dividend.grossInterest">
            <label for="">{{$t('message.grossInterest')}}：</label>
            <vs-input v-model="dividend.grossInterest" type="number" style="width: 100%"></vs-input>
        </div>
        <div class="input-group" v-if="dividend.accumulated">
            <label for="">{{$t('message.accumulated')}}：</label>
            <vs-input v-model="dividend.accumulated" type="number" style="width: 100%"></vs-input>
        </div>
        <div class="input-group" v-if="dividend.rolloverAmount">
            <label for="">{{$t('message.rolloverAmount')}}：</label>
            <vs-input v-model="dividend.rolloverAmount" type="number" style="width: 100%"></vs-input>
        </div>
        <vs-row class="m-t-2">
            <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn m-r-1" @click="onUpdate()">{{$t('message.submit')}}</vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
export default {
    props: ["data"],
    data(){
        return{
            lang: '',
            token: '',
            format: 'dd / MM / yyyy',
            highlight: {
                customPredictor(date) {
                    if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                        return true;
                }
            },
            dividend: this.data,
        }
    },
    created() {
        this.lang = this.$cookies.get('lang');
        this.token = this.$cookies.get('token');
    },
    watch:{
        "data"(newVal){
            this.dividend = newVal;
        },
    },
    methods: {
        onUpdate(){
            this.$emit('update:data', this.dividend);
            this.$emit("update");
        },
    },
    components: {
        Datepicker,
    },
}
</script>

<style scoped>
.input-group {
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 10px;
}
label{
    margin-bottom: 0;
    white-space: nowrap;
    width: 100px;
}
.en label{
    width: 180px;
}
</style>
